var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"admin-user-row"},[_c('td',[_vm._v(_vm._s(_vm.user.username))]),_c('td',[_vm._v(_vm._s(_vm.user.puzzleCount))]),_c('td',{on:{"click":_vm.deleteUser}},[_c('span',{staticClass:"delete-b"},[_vm._v("×")])])])}
var staticRenderFns = []

export { render, staticRenderFns }